import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    shopInfo: {},
    memberInfo: {},
    foodsInfo: {},
    scanInfo: {},
    isScan: false,
    first: 1,
    currency: {},
    tabList: []
	},

	mutations: {},
	actions: {}
})



// WEBPACK FOOTER //
// ./src/vuex/store.js